import { create } from 'zustand';

type WorkstationSessionStoreState = {
  isWorkstationOpen: boolean;
  setIsWorkstationOpen: (workstation: boolean) => void;
};

export const useWorkstationSessionStore = create<WorkstationSessionStoreState>(set => ({
  isWorkstationOpen: false,
  setIsWorkstationOpen: isOpen => set({ isWorkstationOpen: isOpen }),
}));
